import * as React from "react";
import { cn } from "../lib/cn";

export const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-lg border border-border bg-parchment shadow-sm",
      className,
    )}
    {...props}
  />
));
Card.displayName = "Card";
